// Trader section field definitions
// This structure is passed to the backend API when creating a trader section

// ISO 3166-1 compliant country list (matching x-auditsense/src/configs/factoryDataSections.js)
const countries = [
  'Afghanistan',
  'Albania',
  'Algeria',
  'Andorra',
  'Angola',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bosnia and Herzegovina',
  'Botswana',
  'Brazil',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cabo Verde',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, Democratic Republic of the',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czechia',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Timor-Leste',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Fiji',
  'Finland',
  'France',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Greece',
  'Grenada',
  'Guatemala',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Honduras',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Israel',
  'Italy',
  "Côte d'Ivoire",
  'Jamaica',
  'Japan',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Mauritania',
  'Mauritius',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  "Korea (Democratic People's Republic of)",
  'North Macedonia',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'Republic of Korea',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Togo',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Türkiye',
  'Turkmenistan',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Holy See',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

// Trader section field definitions
// This matches the structure used in x-auditsense/src/components/Traceability/ProductInformationFlow/sectionFieldConfigurations.js
export const traderSectionFieldDefinitions = [
  {
    id: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    defaultValue: '',
    gridSize: { xs: 12, sm: 6, md: 3 },
  },
  {
    id: 'address',
    label: 'Street Address',
    type: 'text',
    required: true,
    defaultValue: '',
    gridSize: { xs: 12, sm: 6, md: 3 },
  },
  {
    id: 'city',
    label: 'City',
    type: 'text',
    required: true,
    defaultValue: '',
    gridSize: { xs: 12, sm: 6, md: 3 },
  },
  {
    id: 'stateProvince',
    label: 'State/Province',
    type: 'text',
    required: false,
    defaultValue: '',
    gridSize: { xs: 12, sm: 6, md: 3 },
  },
  {
    id: 'country',
    label: 'Country',
    type: 'select',
    required: true,
    options: countries,
    defaultValue: '',
    gridSize: { xs: 12, sm: 6, md: 3 },
  },
  {
    id: 'certificate_default',
    label: 'Certificate Type: Default',
    type: 'certificate_section',
    additionalInputs: [
      {
        id: 'certificate_default_certificate',
        label: 'Certificate / Standard',
        type: 'select',
        required: true,
        options: [
          'N/A',
          'GRS',
          'GOTS',
          'OCS',
          'RCS',
          'OEKO-TEX',
          'CRADLE TO CRADLE',
          'BLUESIGN',
        ],
        defaultValue: '',
        gridSize: { xs: 12, sm: 6, md: 3 },
      },
      {
        id: 'certificate_default_expirationDate',
        label: 'Expiration Date',
        type: 'date',
        required: false,
        conditionalRequired: true,
        conditional: {
          field: 'certificate_default_certificate',
          condition: 'not_equals',
          value: 'N/A',
        },
        defaultValue: '',
        gridSize: { xs: 12, sm: 6, md: 3 },
      },
      {
        id: 'certificate_default_isProductListed',
        label: 'Is product listed?',
        type: 'select',
        required: false,
        conditionalRequired: true,
        conditional: {
          field: 'certificate_default_certificate',
          condition: 'not_equals',
          value: 'N/A',
        },
        options: ['Yes', 'No', 'Pending'],
        defaultValue: '',
        gridSize: { xs: 12, sm: 6, md: 3 },
      },
      {
        id: 'certificate_default_productCode',
        label: 'Product Code or Page',
        type: 'text',
        required: false,
        conditionalRequired: true,
        defaultValue: '',
        gridSize: { xs: 12, sm: 6, md: 3 },
        conditional: {
          field: 'certificate_default_isProductListed',
          condition: 'equals',
          value: 'Yes',
        },
      },
      {
        id: 'certificate_default_expectedCompletionDate',
        label: 'Expected completion date',
        type: 'date',
        required: false,
        conditionalRequired: true,
        defaultValue: '',
        gridSize: { xs: 12, sm: 6, md: 3 },
        conditional: {
          field: 'certificate_default_isProductListed',
          condition: 'equals',
          value: 'Pending',
        },
      },
      {
        id: 'certificate_default_certificateUpload',
        label: 'Upload Certificate',
        type: 'file',
        required: false,
        conditionalRequired: true,
        conditional: {
          field: 'certificate_default_certificate',
          condition: 'not_equals',
          value: 'N/A',
        },
        accept: '.pdf,.jpg,.jpeg,.png',
        gridSize: { xs: 12, sm: 12, md: 12 },
      },
    ],
  },
  {
    id: 'facilityListedAsSubcontractor',
    label: 'Facility is listed as subcontractor in certificates?',
    type: 'select',
    required: true,
    options: ['Yes', 'No', 'Confirmed Not Applicable'],
    defaultValue: '',
    gridSize: { xs: 12, sm: 12, md: 12 },
  },
];

